import React from "react";
import ReactDOM from "react-dom";
import 'react-toastify/dist/ReactToastify.css';
import Splash from "./Splash";
// import "./css/styles.css";

ReactDOM.render(
  <React.StrictMode>
    <Splash />
  </React.StrictMode>,
  document.getElementById("root")
);
